export const selectedProductFromRow = (row) => ({
  produto: row.produto,
  legacy_id: row.legacy_id,
  label: row.descricao || row.produto,
  category_source: row.category_source,
});

// A linha "Sem Categoria" do scatter nao tem legacy_id, mas tem produtos:
// o backend os lista com sem_categoria=1 em get_collection_product_breakdown.
export const hasProductBreakdown = (row) =>
  !!row?.legacy_id || !!row?.sem_categoria;

export const productMatchesSearch = (product, query) =>
  (product.descricao || "").toLowerCase().includes(query) ||
  String(product.produto || "")
    .toLowerCase()
    .includes(query) ||
  String(product.ean || "")
    .toLowerCase()
    .includes(query);
